import VueRouter, { Location } from "vue-router";

import { ROUTES, VUEX_ROOT_GETTER_NAMES } from "@tt-app/constants";
import store from "@tt-app/store";
import { TERRATALK_LIVE_ROUTES } from "@tt-app/constants/router/terratalkLive";

/**
 * Exit:
 * - If there is a previous page, move back to the previous page
 * - If there is no previous page (user directly accessed an URL), move to a
 *   fallback link
 *
 * @param router VueRouter instance
 * @param ttLiveSessionActive flag for tt live active session
 * @param fallback optional fallback destination. If undefined, backActions
 * @param routeParams optional params to be passed to target component
 * falls back to the home page
 */
export const onTtBackAction = (
  router: VueRouter,
  ttLiveSessionActive: boolean,
  fallback?: Location,
  routeParams?: any
) => {
  const previousRoute = store.getters[VUEX_ROOT_GETTER_NAMES.PREVIOUS_ROUTE];

  const previousRouteName = fallback?.name || previousRoute.name;

  let destination: Location;
  if (ttLiveSessionActive) {
    destination = { name: TERRATALK_LIVE_ROUTES.LOBBY.NAME };
  } else if (previousRouteName) {
    destination = { name: previousRouteName, params: routeParams };
  } else {
    destination = { name: ROUTES.HOME.NAME, params: routeParams };
  }

  router.push(destination);
};
